import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import EditButton from 'components/button/EditButton';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import PropertygroupsShow from './PropertygroupsShow';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceAndLocalisationById from 'components/hoc/fetchResourceAndLocalisationById';
import translate from 'components/hoc/translate';
import { fetchPropertygroup } from 'store/actions/propertygroups/fetchPropertygroups';

class PropertygroupsShowContainer extends React.Component {
    render() {
        const {
            data,
            localisation,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.propertygroups.plural'),
                link: '/propertygroups',
            },
            {
                label: data.name,
                link: `/propertygroups/${ data.id }/show`,
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.propertygroups.actions.show', { title: data.name }) } />

                    <Actions>
                        <EditButton
                            url={ `/propertygroups/${ data.id }` }
                        />

                        <ListButton url='/propertygroups' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <PropertygroupsShow
                            data={ data }
                            localisation={ localisation }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

PropertygroupsShowContainer.propTypes = {
    data: PropTypes.object,
    localisation: PropTypes.object,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    fetchResourceAndLocalisationById({
        action: fetchPropertygroup,
        resource: 'propertygroups',
    })
);

export default enhance(PropertygroupsShowContainer);



// WEBPACK FOOTER //
// ./src/pages/propertygroups/show/PropertygroupsShowContainer.js